"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtServiceNS = void 0;
var JwtServiceNS;
(function (JwtServiceNS) {
    JwtServiceNS.ServiceComponentKey = "JwtService";
})(JwtServiceNS = exports.JwtServiceNS || (exports.JwtServiceNS = {}));
//# sourceMappingURL=jwt-service.types.js.map